// extracted by css-extract-rspack-plugin
export default {"root":"root-dv9g3n"};